import * as React from "react";
import dayjs from "dayjs";
import { makeStyles } from "@material-ui/core/styles";
import IconCheck from "@material-ui/icons/Check";
import TextField from "@mui/material/TextField";
import { FormGroup, FormLabel } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

const useStyles = makeStyles({
  datePicker: {
    "& .MuiPickersModal-dialog": {
      backgroundColor: "var(--dark) !important",
    },
    "& .MuiDialogActions-spacing ": {
      backgroundColor: "var(--darker) !important",
    },
    "& .MuiDialogActions-spacing .MuiButton-label": {
      color: "var(--darker)",
    },
    "& .MuiPickersModal-dialog .MuiPickersBasePicker-container .MuiToolbar-root": {
      backgroundColor: "var(--darker)  !important",
    },
  },
});

export default function TimeRange(props) {
  // const classes = useStyles();

  // const [anchorEl, setAnchorEl] = React.useState(null);
  const [minTime, setMinTime] = React.useState(dayjs(new Date()));
  const [maxTime, setMaxTime] = React.useState(dayjs(new Date()));

  // React.useEffect(() => {
  //   setMinTime(dayjs(new Date(props.value.min)));
  // }, [props.value.min]);

  // React.useEffect(() => {
  //   setMaxTime(dayjs(new Date(props.value.max)));
  // }, [props.value.max]);

  // const [isSet,setIsSet]=React.useState(false)

  // const momentToHrs=(date)=>
  // {
  //   if(typeof date!=Date)
  //   date=new Date()
  //   let hours=date.getHours();
  //   let minutes=date.getMinutes()
  //   if (hours < 10) { hours = "0" + hours; }
  //   if (minutes < 10) { minutes = "0" + minutes; }
  //   let datef=`${hours}:${minutes}`;
  //   return datef;
  // }

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const handleMinUpdate = (val) => {
    setMinTime(val);
  };

  React.useEffect(() => {
    // if (anchorEl) {
    const delayUpdate = setTimeout(() => {
      handleChange({ min: minTime.toDate(), max: maxTime.toDate() });
    }, 1000);
    return () => {
      clearTimeout(delayUpdate);
    };
    // }
  }, [minTime, maxTime]);

  const handleMaxUpdate = (val) => {
    setMaxTime(val);
  };

  // const open = Boolean(anchorEl);
  // const id = open ? "simple-popover" : undefined;

  const handleChange = (val) => {
    if (props.onChange) props.onChange(val);
  };

  // React.useEffect(()=>{
  //   if(JSON.stringify(props.value)!=JSON.stringify(props.defaultValue))
  //   setIsSet(true)
  // },[props.value])

  // const handleClear = (e) => {
  //   e.stopPropagation();
  //   handleChange({ min: "", max: "" });
  //   handleReset();
  //   // setIsSet(false);
  // // };
  // const handleReset = () => {
  //   if (props.onReset) props.onReset();
  // };

  return (
    <FormGroup
      sx={{
        "&.MuiFormControl-root": {
          display: "block",
        },
        padding: "0 1rem",
      }}
    >
      <FormLabel
        sx={{
          display: "block",
          fontWeight: "700",
          textAlign: "start",
          color: "#000000",
        }}
      >
        {props.label}
      </FormLabel>
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            label="Min Time"
            value={minTime}
            onChange={handleMinUpdate}
            renderInput={(params) => <TextField {...params} />}
            style={{ fontSize: "0.85rem" }}
          />
        </LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            label="Max Time"
            value={maxTime}
            onChange={handleMaxUpdate}
            renderInput={(params) => <TextField {...params} />}
            style={{ fontSize: "0.85rem" }}
          />
        </LocalizationProvider>
      </div>
    </FormGroup>
  );
}

TimeRange.defaultProps = {
  value: { min: new Date(), max: new Date() },
};
